var map = {
	"./ar/message.json": "./src/locale/ar/message.json",
	"./cy/message.json": "./src/locale/cy/message.json",
	"./cz/message.json": "./src/locale/cz/message.json",
	"./da/message.json": "./src/locale/da/message.json",
	"./de/message.json": "./src/locale/de/message.json",
	"./en/message.json": "./src/locale/en/message.json",
	"./es/message.json": "./src/locale/es/message.json",
	"./fi/message.json": "./src/locale/fi/message.json",
	"./fr/message.json": "./src/locale/fr/message.json",
	"./hu/message.json": "./src/locale/hu/message.json",
	"./it/message.json": "./src/locale/it/message.json",
	"./ja/message.json": "./src/locale/ja/message.json",
	"./ko/message.json": "./src/locale/ko/message.json",
	"./kz/message.json": "./src/locale/kz/message.json",
	"./nl/message.json": "./src/locale/nl/message.json",
	"./pl/message.json": "./src/locale/pl/message.json",
	"./pt/message.json": "./src/locale/pt/message.json",
	"./ro/message.json": "./src/locale/ro/message.json",
	"./ru/message.json": "./src/locale/ru/message.json",
	"./sk/message.json": "./src/locale/sk/message.json",
	"./sv/message.json": "./src/locale/sv/message.json",
	"./vn/message.json": "./src/locale/vn/message.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/message\\.json$";